export const mediaQueries = {
  phoneSize: '(min-width:375px)',
  tableSize: '(min-width:768px)',
  laptopSize: '(min-width:1024px)',
}